import http from '@/utils/http'
import { logError } from '@/utils/logger'
import { duration, transformDate } from '@/utils/date'
import { ElMessage } from 'element-plus'

const PER_PAGE = 8

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list.map(item => {
      item.startDate = transformDate(item.JobStart)
      item.endDate = transformDate(item.JobEnd)

      // calculating duration
      let eventDuration = '-'

      const startDate = transformDate(item.JobStart, false)
      const endDate = transformDate(item.JobEnd, false)

      if (startDate && endDate) {
        eventDuration = duration(endDate, startDate)
      }

      item.duration = eventDuration

      return item
    })
  }
}

export const getters = {
  list: state => state.list,
  itemsPerPage: () => PER_PAGE,
  total: state => (state.list[0] && state.list[0].TotalCount) || 0
}

export const actions = {
  // failedOnly must be proper boolean (true/false) - not a truthy/falsy value
  fetchEvents ({ commit, rootGetters }, { jobId, page = 1, failedOnly = false }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}job/eventspaged/${rootGetters['auth/token']}/${jobId}/${page}/${PER_PAGE}/${failedOnly}`
    }).then(data => {
      commit('SET_LIST', data)

      return data
    }).catch(e => {
      ElMessage.warning('Error loading events')

      logError(e, { jobId, page, failedOnly }, 'record: error loading job events')

      throw e
    })
  }
}
